import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function useMuses() {
  const [state, setState] = useState({ loading: true, muses: [], example: null, limit: 1, count: 0 });
  useEffect(() => {
    api.get("/muses").then(({ data }) => setState({ loading: false, ...data })).catch(() => setState((s) => ({ ...s, loading: false })));
  }, []);
  return state;
}
